export { default as AsideNews } from "./AsideNews";
export { default as ArticleItems } from "./ArticleItems";
export { default as BigNewsSection } from "./BigNewsSection";
export { default as AsideArchive } from "./AsideArchive";
export { default as NTContainer } from "./NTContainer";
export { default as TendersItems } from "./TendersItems";
export { default as GallerySection } from "./GallerySection";
export { default as RandomNews } from "./RandomNews";
export { default as NewsListPageHeader } from "./NewsListPageHeader";
export { default as ShareButton } from "./ShareButton";
